import testimonialA from '../images/icons_assets/49.jpg';
import testimonialB from '../images/icons_assets/32.jpg';
import testimonialC from '../images/icons_assets/90.jpg';
import testimonialD from '../images/icons_assets/16.jpg';

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Mary Jane',
    image: testimonialA,
    review: '“We had such a great time celebrating my grandmothers bitthday!”',
    stars: 5,
  },

  {
    id: 2,
    name: 'Carlos Gonzalez',
    image: testimonialB,
    review: '“We had such a great time celebrating my grandmothers bitthday!”',
    stars: 5,
  },

  {
    id: 3,
    name: 'Jhon do',
    image: testimonialC,
    review: '“We had such a great time celebrating my grandmothers bitthday!”',
    stars: 5,
  },

  {
    id: 4,
    name: 'Ingrid Green',
    image: testimonialD,
    review: '“We had such a great time celebrating my grandmothers bitthday!”',
    stars: 5,
  },
];
